import { useTranslation } from 'react-i18next'
import TopBar from '@/src/components/layout/top-bar/TopBar'
import { VpButton } from '@vtmn-play/react'
import ErrorContent from '@/src/components/global/error-content/ErrorContent'

const Error404 = () => {
  const { t } = useTranslation('common')

  return (
    <div className="h-dvh flex flex-col">
      <TopBar variant="dark" title={t('components.error.404-title')} />
      <main className="flex-1 overflow-hidden bg-primary-blue pt-2">
        <div className="h-full flex flex-col">
          <div className="bg-white rounded-t-2xl p-6 flex-1 flex flex-col justify-between">
            <div className="flex flex-col items-center text-center justify-center flex-1">
              <ErrorContent message={t('components.error.404-message')} />
            </div>
            <VpButton
              className="w-full mt-6"
              shape="squared"
              onClick={() => window.location.assign('/')}
            >
              {t('global.back-home')}
            </VpButton>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Error404
